import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { userMenuTranslationRef } from './userMenu';

export const userMenuTranslations = createTranslationResource({
  ref: userMenuTranslationRef,
  translations: {
    'pt-BR': () => import('./userMenu-pt-BR'),
  },
});

export { userMenuTranslationRef } from './userMenu';

